<template>
  <div class="view-bg" ref="scrollWrapper">
    <div class="invite-cash-back">
      <!-- 立邀好友赚钱按钮 -->
      <span class="share-btn" @click="drawerToggle = true"></span>
      <!-- 活动介绍 -->
      <div class="box-area hd-describe">
        <div
          class="area-upper d-flex justify-content-between align-items-center"
        >
          <div class="d-flex flex-column align-items-start text-info">
            <span class="tag">第1步：邀请好友注册</span>
            <p class="content">邀请好友注册 各得100金币</p>
            <p class="tip">*金币只可用于平台内消费 不能提现</p>
          </div>
          <div class="describe-upper-pic"></div>
        </div>
        <div
          class="area-lower d-flex justify-content-between align-items-center"
        >
          <div class="describe-lower-pic"></div>

          <!-- 投顾老师 -->
          <div
            class="d-flex flex-column align-items-start text-info"
            v-if="isTeacher"
          >
            <span class="tag">第2步：好友开通会员</span>
            <p class="teacher-content">
              由于您是平台投顾老师，可享用户消费抽成，具体请咨询运营专员
            </p>
          </div>

          <!-- 普通用户 -->
          <div class="d-flex flex-column align-items-start text-info" v-else>
            <span class="tag">第2步：好友开通会员</span>
            <p class="content">好友开通会员</p>
            <p class="content">
              您将获得 <span class="special-color">20%现金返还</span>
            </p>
            <p class="tip">*开通平台任意高手会员均可</p>
          </div>
        </div>
        <span
          v-if="isTeacher"
          @click="navigatAppTo('custom_operate', '')"
          class="d-flex align-items-center justify-content-center btn"
          >咨询运营专员</span
        >
      </div>

      <!-- 我的奖励 -->
      <div class="box-area my-prize" v-if="!isTeacher">
        <div class="area-tag">我的奖励</div>
        <div class="d-flex">
          <div class="area-col">
            <span class="prize-t">邀请好友</span>
            <p>
              <b>{{ data.register_num || 0 }}</b
              >位
            </p>
          </div>
          <div class="area-col">
            <span class="prize-t">返现金额</span>
            <p>
              ¥<b>{{ data.commissions || "0.00" }}</b
              >元
            </p>
          </div>
          <div class="area-col">
            <span class="prize-t">金币奖励</span>
            <p>
              <b>{{ data.give_golds || 0 }}</b
              >枚
            </p>
          </div>
        </div>
        <span
          class="d-flex align-items-center justify-content-center btn"
          @click="navigatAppTo('withdrawal', '')"
          >立即提现</span
        >
      </div>

      <!-- 邀请记录 -->
      <div class="box-area invite-records" v-if="!isTeacher">
        <div class="area-tag">邀请记录</div>
        <div
          class="d-flex justify-content-center flex-column empty-content"
          v-if="!inviteRecords.length"
        >
          <p>暂无邀请记录</p>
          <p>快去邀请好友赚钱吧～</p>
        </div>
        <template v-else>
          <ul>
            <li v-for="item in inviteRecords" :key="item.id">
              <div class="d-flex">
                <div class="d-flex justify-content-start u-info">
                  <img :src="item.referred_user.avatar" />
                  <div class="d-flex justify-content-center flex-column">
                    <b class="u-info__number">{{ item.referred_user.mobile }}</b
                    ><time>{{ item.created_at }}</time>
                  </div>
                </div>
                <div
                  class="d-flex flex-column justify-content-center u-logined"
                >
                  <template v-if="item.is_sign_in">
                    已登录<b class="special-color"
                      >+{{ item.give_golds || 0 }}金币</b
                    >
                  </template>
                  <template v-else>
                    <span class="gray-yellow-color">未登录</span
                    ><b class="gray-yellow-color">-</b>
                  </template>
                </div>
                <div class="d-flex flex-column justify-content-center u-vip">
                  <template v-if="item.is_open_vip">
                    <span>已开通VIP</span>
                    <b class="special-color">+{{ item.commissions }}元</b>
                  </template>
                  <template v-else>
                    <span class="gray-yellow-color">未开通VIP</span
                    ><b class="gray-yellow-color">-</b>
                  </template>
                </div>
              </div>
              <p
                v-if="item.state_tip"
                class="u-state waiting-icon"
                :class="{ 'invalid-icon': item.live_vip_is_closed }"
              >
                {{ item.state_tip }}
              </p>
            </li>
          </ul>
          <router-link
            class="more"
            :to="{
              name: 'inviteRecords',
              params: { token: token, userID: userID },
            }"
            tag="p"
            >查看邀请详情<span class="mark"></span
          ></router-link>
        </template>
      </div>

      <!-- 规则说明 -->
      <div class="box-area activity-rule">
        <div class="area-tag">规则说明</div>
        <section>
          <p>
            1.将本活动页面分享给好友，让好友通过你的分享链接领取红包，下载并登录爱股票App，你和好友即可各得100金币（金币只可用于平台内消费
            不能提现）。
          </p>
          <p>
            2.你邀请的好友首次开通平台任意高手会员后，你可获得好友实付金额20%的返现奖励（每个邀请的好友仅首次开通会员你可享受返现）。
          </p>
          <p>
            3.被邀请的好友使用的手机号必须是之前从未下载过且从未登录过爱股票App的才记为有效，手机号需为中国大陆地区归属。
          </p>
          <p>
            4.邀请好友数量无上限，获得金币受任务中心每月金币奖励上限限制，开会员返现金奖励不受限制，邀请越多奖励越多！
          </p>
          <p>
            5.你邀请的好友开通会员后返现奖励可在邀请记录页查看，好友会员服务期结束后返现金额可提现到银行卡，提现申请在结算日的3个工作日内打款。
          </p>
          <p>
            6.利用漏洞、虚假信息或以不正当方式参与获得奖励者，爱股票有权取消相关账户的参与资格和获奖资格。最终解释权归爱股票所有。
          </p>
        </section>
      </div>
      <footer class="d-flex justify-content-center align-items-center footer">
        <span class="customer-service-icon"></span
        ><span @click="navigatAppTo('custom_service', '')">联系客服</span>
      </footer>
    </div>
    <transition name="fade">
      <div
        class="mask-layer"
        v-if="drawerToggle && false"
        @touchmove.stop
        @click="drawerToggle = false"
      ></div>
    </transition>
    <ShareDrawer v-if="false" :drawerToggle.sync="drawerToggle" :shareInfo="shareInfo" />
    <!-- 预加载以下图片 -->
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/weibo@2x.png"
      as="image"
    />
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qq_icon@2x.png"
      as="image"
    />
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qqzone_icon@2x.png"
      as="image"
    />
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/weibo@3x.png"
      as="image"
    />
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qq_icon@3x.png"
      as="image"
    />
    <link
      rel="preload"
      href="https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qqzone_icon@3x.png"
      as="image"
    />
  </div>
</template>

<script>
// import Vue from 'vue';
import { Toast } from 'vant';
import ShareDrawer from "./components/shareDrawer";
import "@/utils/flexible";
import * as utils from "@/utils/index";
import * as Api from "@/api/activity/inviteCashBack.js";
// import inobounce from "inobounce";
// import BetterScroll from "better-scroll";

export default {
  name: "inviteCashBack",
  data() {
    return {
      token: this.$route.query.access_token,
      userID: this.$route.query.user_id,
      liveID: this.$route.query.live_id,
      isTeacher: false,
      inviteRecords: [],
      data: {},
      drawerToggle: false,
      shareInfo: {},
      scroll: null,
    };
  },
  components: {
    ShareDrawer,
  },
  created() {
    // 该功能已下线
    Toast({
      type: "fail",
      message: "该功能已下线",
      overlay: true,
      duration: 0
    })

    // 获取用户活动信息
    // this.getActivityInfo();
    // 获取活动邀请记录
    // this.getInviteRecords();
    // 记录访问日志
    // this.recordLog(0);
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs["scrollWrapper"], {
    //     bounce: false,
    //     momentumLimitTime: 150,
    //     swipeTime: 1500,
    //     click: true,
    //   });
    // });
  },
  methods: {
    navigatAppTo(tag, id) {
      this.$igpJumpToNative(tag, id);
    },
    getActivityInfo() {
      Api.account({
        token: this.token,
        params: {
          user_id: this.userID,
          live_id: this.liveID,
        },
      })
        .then((res) => {
          utils.logic(res, (data) => {
            this.data = data;
            this.isTeacher = data.inviter_service_vip;

            // 根据来源设置不同的分享文案
            if (!data.live_id) {
              // 推荐爱股票APP给好友
              this.shareInfo = {
                share_link: data.share_url,
                share_logo:
                  "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/share_logo.png",
                share_title: "送你爱股票新人红包！加入专业股市投资者社区！",
                share_content:
                  "我一直用爱股票，跟牛人学习炒股，免费看高手持仓！赶快下载吧~",
                share_moments_title:
                  "我一直用爱股票，跟牛人学习炒股，免费看高手持仓！赶快下载吧~",
                share_qr: data.share_url,
              };
            } else {
              // 分享老师会员给好友
              this.shareInfo = {
                share_link: data.share_url,
                share_logo:
                  "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/share_logo.png",
                share_title: `${data.user_nickname}推荐你加入${data.live_name}的会员！登录领取新人红包！`,
                share_content:
                  "我一直用爱股票，跟牛人学习炒股，免费看高手持仓！赶快下载吧~",
                share_moments_title:
                  "我一直用爱股票，跟牛人学习炒股，免费看高手持仓！赶快下载吧~",
                share_qr: data.share_url,
              };
            }
          });
        })
        .catch((err) => {
          this.$message.error("系统错误");
          throw Error(err);
        });
    },
    getInviteRecords() {
      Api.records({
        token: this.token,
        params: {
          user_id: this.userID,
          limits: 3,
        },
      })
        .then((res) => {
          utils.logic(res, (data) => {
            this.inviteRecords = data;
            // this.scroll.refresh();
          });
        })
        .catch((err) => {
          this.$message.error("系统错误");
          throw Error(err);
        });
    },
    recordLog(type) {
      let params = {};
      (params.page = type),
        (params.user_id = this.userID),
        (params.source = this.liveID ? "老师主页" : "个人中心");

      Api.recordLog(params)
        .then((res) => {
          utils.logic(res, (data) => {
            // eslint-disable-next-line no-console
            console.log(data.message);
          });
        })
        .catch((err) => {
          this.$message.error("系统错误");
          throw Error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.view-bg {
  background: linear-gradient(to right, #ff7130, #ff9c29);
  user-select: none;
  // height: 100vh;
  // overflow: hidden;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  b {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
}
.invite-cash-back {
  position: relative;
  width: rem(750px);
  margin: 0 auto;
  @include bg-image(
    "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/kv",
    "jpg"
  );
  background-position: top center;
  min-height: 100vh;
  font-family: PingFangSC-Regular, PingFang SC;
  box-sizing: border-box;
  padding-top: rem(664px);
  border-bottom: rem(1px) solid transparent;
  div,
  p,
  span {
    font-weight: 400;
  }
  .special-color {
    font-weight: bold;
  }
}
.share-btn {
  position: absolute;
  display: block;
  width: rem(480px);
  height: rem(100px);
  top: rem(518px);
  left: rem(136px);
}
.box-area {
  position: relative;
  width: rem(690px);
  margin: 0 auto rem(66px);
  border: rem(8px) solid #fda906;
  border-radius: rem(20px);
  box-sizing: border-box;
  background-color: #fff2e3;
  &:last-child {
    margin-bottom: 0;
  }
  .area-tag {
    position: absolute;
    top: rem(-28px);
    left: 50%;
    margin-left: rem(-189px);
    text-align: center;
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/area_tag",
      "png"
    );
    background-position: top center;
    width: rem(378px);
    line-height: rem(78px);
    font-size: rem(30px);
    color: #c16512;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}

// 活动介绍
.hd-describe {
  padding-top: rem(38px);
  padding-bottom: rem(46px);
  .area-upper {
    margin: 0 rem(40px) rem(35px) rem(32px);
    padding-bottom: rem(51px);
    @include setBottomLine(#e7d6b5);
  }
  .area-lower {
    padding: 0 rem(73px) 0 rem(20px);
    .tag {
      margin-bottom: rem(18px);
    }
  }

  .describe-upper-pic {
    width: rem(196px);
    height: rem(150px);
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/describe_upper_pic",
      "png"
    );
  }
  .describe-lower-pic {
    flex: 0 0 rem(228px);
    height: rem(176px);
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/describe_lower_pic",
      "png"
    );
  }
  .tag {
    display: inline-flex;
    line-height: rem(48px);
    font-size: rem(24px);
    padding: rem(0px) rem(25px);
    background-image: linear-gradient(to right, #ff6646, #ff1211);
    border-radius: rem(24px);
    margin-bottom: rem(23px);
    color: #ffe9bf;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }

  p.content {
    color: #b25a0b;
    font-size: rem(32px);
    line-height: rem(38px);
    margin-bottom: rem(10px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
  }
  p.teacher-content {
    color: #b45a00;
    font-size: rem(28px);
    line-height: rem(40px);
  }
  p.tip {
    color: #c19e7f;
    font-size: rem(24px);
    margin-top: rem(6px);
    font-family: TXWDHJW--GB1-0, TXWDHJW--GB1;
    line-height: rem(38px);
  }
  .btn {
    margin-top: rem(36px);
  }
}

// 我的奖励
.my-prize {
  padding-top: rem(83px);
  padding-bottom: rem(39px);
  div {
    flex: 1;
    text-align: center;
  }
  .prize-t {
    display: block;
    font-size: rem(26px);
    height: rem(37px);
    line-height: rem(37px);
    color: #c37c3c;
    font-weight: 400;
  }
  p {
    font-size: rem(28px);
    color: #b25a0b;
    line-height: rem(58px);
    font-weight: 400;
    margin-top: rem(32px);
    margin-bottom: rem(47px);
  }
  b {
    font-size: rem(30px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin: 0 rem(4px);
  }
}

// 邀请记录
.invite-records {
  padding-top: rem(83px);
  .empty-content {
    height: rem(226px);
    text-align: center;
    p {
      margin-bottom: rem(20px);
      color: #b25a0b;
      font-size: rem(28px);
    }
  }
  ul {
    padding: 0 rem(34px);
    margin-bottom: rem(25px);
  }
  li {
    @include setBottomLine(#dad2cf);
    padding-bottom: rem(16px);
    margin-bottom: rem(25px);
    &:last-child {
      margin-bottom: 0;
    }
  }
  .u-info {
    color: #5e4732;
    flex: 1;
    img {
      width: rem(80px);
      height: rem(80px);
      border: rem(3px) solid #fda906;
      border-radius: 50%;
      margin-right: rem(24px);
    }
    .u-info__number {
      font-size: rem(26px);
      line-height: rem(37px);
    }
    time {
      margin-top: rem(6px);
      line-height: rem(33px);
      font-size: rem(24px);
    }
  }
  .u-logined,
  .u-vip {
    flex: 1;
    color: #5e4732;
    font-size: rem(26px);
    line-height: rem(37px);
    text-align: right;
    b {
      margin-top: rem(6px);
      line-height: rem(33px);
      font-size: rem(24px);
    }
  }
  .waiting-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/waiting_icon",
      "png"
    );
  }
  .invalid-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/invalid_icon",
      "png"
    );
  }
  .u-state {
    color: #a48b83;
    font-size: rem(24px);
    line-height: rem(33px);
    margin-top: rem(15px);
    background-position: left center;
    background-size: rem(20px) rem(20px);
    padding-left: rem(26px);
  }
  .more {
    line-height: rem(72px);
    font-size: rem(26px);
    color: #fff;
    background: #fda906;
    text-align: center;
    .mark {
      display: inline-block;
      width: 0;
      height: 0;
      vertical-align: middle;
      margin-left: rem(10px);
      border-top: rem(10px) solid transparent;
      border-left: rem(10px) solid #fff;
      border-bottom: rem(10px) solid transparent;
    }
  }
}

// 规则说明
.activity-rule {
  padding: rem(83px) rem(43px) rem(20px);
  margin-bottom: 0;
  p {
    font-size: rem(26px);
    line-height: rem(40px);
    color: #b25a0b;
    margin-bottom: rem(20px);
  }
}

.btn {
  width: rem(431px);
  height: rem(80px);
  background: linear-gradient(to bottom, #ff8c57, #ff4d21);
  box-shadow: 0 rem(4px) rem(10px) 0 rgba(206, 69, 41, 0.3);
  font-size: rem(30px);
  color: #fff;
  border-radius: rem(40px);
  margin: 0 auto;
  font-weight: 400;
}

.gray-yellow-color {
  color: #a48b83;
}

.special-color {
  color: #ff4949;
}

.footer {
  height: rem(37px);
  padding: rem(43px) 0 rem(233px);
  font-size: rem(26px);
  color: #fff;
  .customer-service-icon {
    display: block;
    width: rem(36px);
    height: rem(36px);
    margin-right: rem(10px);
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/customer_service",
      "png"
    );
  }
}
.mask-layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
